export function getCustomMethod(state) {
	return state.customMethod;
}

export function getInitialRoute() {
	return process.env.VUE_APP_INITIAL_ROUTE || 'dashboard';
}
